import React, { useEffect, useState } from "react"
import { Modal, Input, ConfigProvider } from "antd"
import { DeleteOutlined, FileTextOutlined } from "@ant-design/icons"
import { useAuth } from "../lib/useAuth"
import { getLogContent } from "../services/logsApis"

const { TextArea } = Input

const theme = {
    components: {
        Modal: {
            contentBg: "#0d1117",
            contentColor: "#c9d1d9",
            headerBg: "#0d1117",
            titleColor: "#c9d1d9",
        },
    },
}

const LogsModal = ({ service, id }) => {
    const { user, isAuthenticated } = useAuth()
    const [isOpen, setIsOpen] = useState(false)
    const [logContent, setLogContent] = useState("لاگی برای نمایش وجود ندارد")

    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    useEffect(() => {
        if (isOpen && isAuthenticated) {
            getLogContent({ service, id })
                .then((res) => {
                    setLogContent(res?.data?.data?.content || res?.data?.data)
                })
                .catch(() => {})
        }
    }, [isAuthenticated, isOpen])

    return (
        <>
            <button onClick={toggleModal}>
                <FileTextOutlined />
            </button>
            <ConfigProvider theme={theme}>
                <Modal
                    title={`لاگ های ${service.fa}`}
                    open={isOpen}
                    styles={{}}
                    okText="ویرایش"
                    onOk={toggleModal}
                    onCancel={toggleModal}
                    footer={[]}
                    style={{ minHeight: "600px", maxHeight: "600px", minWidth: "1000px" }}
                >
                    {user.scope === "admin" ? (
                        <button className="styled-button danger mb-2">
                            <span>حذف</span>
                            <DeleteOutlined />
                        </button>
                    ) : null}

                    <TextArea
                        dir="ltr"
                        style={{ color: "#c9d1d9" }}
                        rows={15}
                        value={logContent}
                        maxLength={6}
                        disabled={true}
                    />
                </Modal>
            </ConfigProvider>
        </>
    )
}

export default LogsModal
